import { render, staticRenderFns } from "./CommerceDebutGuideSideMenu.vue?vue&type=template&id=4633f6ca&scoped=true"
import script from "./CommerceDebutGuideSideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommerceDebutGuideSideMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommerceDebutGuideSideMenu.vue?vue&type=style&index=0&id=4633f6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4633f6ca",
  null
  
)

export default component.exports